const initState = {
    jobs: [
        {id: "1", title: "Job One", content: "Software Engineering job"},
        {id: "2", title: "Job 2", content: "Software Engineering job"},
        {id: "3", title: "Job 3", content: "Software Engineering job"},
    ]
};

const projectReducer = (state = initState, action) => {
  return state;
};

export default projectReducer;
